<template>
<span id="print-labels" v-if="isVisible()">
  <el-button
    id="btn-print-all"
    type="success"
    plain
    @click="handlePrintAllLabels()"
    size="mini"
    v-show="displayButton"
  >
    {{ $t('outbound.units.printLabels') }}
  </el-button>
</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Loading, Message } from 'element-ui';
import constants from '@/utils/constants';
import { OUTBOUND_UNITS_PRINT_ALL_LABELS, OUTBOUND_UNITS_SEARCH } from '@/store/actions';

export default {
  name: 'PrintLabels',
  props: {
    validateSearch: Function,
    displayButton: Boolean
  },
  computed: {
    ...mapGetters([
      'outboundUnits'
    ])
  },
  methods: {
    ...mapActions({
      printAllLabels: OUTBOUND_UNITS_PRINT_ALL_LABELS,
      search: OUTBOUND_UNITS_SEARCH,
    }),
    isVisible() {
      return this.outboundUnits.list.length > 0 && this.outboundUnits.currentView !== 'outbound.units.deletedUnits';
    },
    async handlePrintAllLabels() {
      Message.closeAll();
      if (!this.validateSearch()) return;
      const loading = Loading.service(constants.LOADING.PRINT_CONFIG);
      try {
        await this.printAllLabels().catch(() => {});
        this.search({});
      } finally {
        loading.close();
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#print-labels #btn-print-all {
  margin-left: 10px;
}
</style>
